import { FC } from 'react';
import { ArrayField, Multistep, useFormState } from 'informed';
import { IYupSchema, STEPS, STEPS_ICONS, STEPS_LABELS } from '../../consts';
import InformedField from '../InformedField';
import Subtitle from '../Subtitle';
import Navigation from '../Navigation';
import { Button, Dropdown } from '@components';
import DualListField from '../DualListField';
import { TrashIcon } from '@assets/svg';
import { DataItem } from '@common/interfaces';
import css from './styles.module.scss';

interface IAssetStep {
  setYupSchema: React.Dispatch<React.SetStateAction<IYupSchema>>;
  assetsOptions: DataItem[];
  repairsOptions: DataItem[];
}

const ServicesError = () => {
  const { errors, touched } = useFormState();
  const error = (errors?.asset as any)?.services;
  const isTouched = (touched?.asset as any)?.services;
  if (!isTouched) return null;
  if (typeof error !== 'string') return null;
  return <div className={css.error}>{error}</div>;
};

const AssetStep: FC<IAssetStep> = ({ setYupSchema, assetsOptions, repairsOptions }) => {
  return (
    <Multistep.Step step={STEPS.ASSET}>
      <Subtitle text={STEPS_LABELS.ASSET} icon={STEPS_ICONS.ASSET} />
      <ServicesError />
      <ArrayField name='services'>
        {({ add }) => (
          <>
            <ArrayField.Items>
              {({ remove, name, index, resetField }) => {
                // TO DO: Do we need match reparis with assets?
                // const values = useArrayFieldItemState(); // TO DO: Why it's not working
                // const { value } = useFieldState(`services[${index}].type_of_asset`);
                // const { value: services = [] } = useFieldState(`services`);
                // const type_of_asset = value as IDropdownOption;
                // const repairOptions = type_of_asset?.value
                //   ? options[type_of_asset.value as keyof typeof options] || []
                //   : [];
                // const types_of_assets = (services as AssetServiceValue[]).map(
                //   ({ type_of_asset }) => type_of_asset?.value || '0'
                // );
                // const assetsOptions = dummyOptions.filter(({ value }) => !types_of_assets.includes(value));

                return (
                  <div key={`${name}-${index}`} className={css.fieldBox}>
                    <InformedField label='Type of asset'>
                      <div className={css.row}>
                        <Dropdown
                          className={css.dropdown}
                          placeholder='Select type of asset'
                          name='type_of_asset'
                          options={assetsOptions}
                          variant='dark'
                          onChange={() => resetField('type_of_repairs')}
                        />
                        {index !== 0 ? <Button iconL={<TrashIcon />} variant='icon' onClick={remove} /> : null}
                      </div>
                    </InformedField>
                    <InformedField>
                      <DualListField
                        name='type_of_repairs'
                        options={repairsOptions}
                        leftTitle='Available type of repair'
                        rightTitle='Chosen type of repair'
                      />
                    </InformedField>
                  </div>
                );
              }}
            </ArrayField.Items>
            <Button type='button' variant='text' text='Add Service +' onClick={() => add()} />
          </>
        )}
      </ArrayField>
      <Navigation setYupSchema={setYupSchema} />
    </Multistep.Step>
  );
};

export default AssetStep;
